import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'progress-spinner',
    styleUrl: 'progress-spinner.component.scss',
    templateUrl: 'progress-spinner.component.html',
    standalone: false
})
export class ProgressSpinnerComponent { }
